export const INVENTORY_COUNT_CANCELED = -1
export const INVENTORY_COUNT_PENDING = 0
export const INVENTORY_COUNT_COMPLETE = 1

export const Statuses = [
  {
    code: INVENTORY_COUNT_CANCELED,
    label: 'Canceled',
    color: 'red',
    icon: 'fas fa-times-circle'
  },
  {
    code: INVENTORY_COUNT_PENDING,
    label: 'Pending',
    color: 'orange',
    icon: 'fas fa-question-circle'
  },
  {
    code: INVENTORY_COUNT_COMPLETE,
    label: 'Completed',
    color: 'green',
    icon: 'fas fa-check-circle'
  }
]

export default Statuses
